import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Col, Row, Form, Button } from '_zari/core'

import * as CajaChicaService from 'services/cajaChica.service'

import * as FormGroups from './formGroups'
import ValidationSchema from './validacion'

const MainForm = ({ idSocio, idTituloViatico, mostrarListaSection, editarData }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      _idTrabajadorViatico: idSocio,
      _idTituloViatico: idTituloViatico,
      fechaEmision: editarData.fechaEmision ?? '',
      tipoCambio: editarData.tipoCambio ?? '',
      glosa: editarData.glosa ?? '',
      moneda: editarData.moneda ?? '',
      importe: editarData.importe ?? '',
      cuentaContable: editarData.cuentaContable ?? '',
      cuentaContableInfo: editarData.cuentaContableInfo ?? '',
      _idCentroCostoNivel1: editarData._idCentroCostoNivel1 ?? '',
      _idCentroCostoNivel2: editarData._idCentroCostoNivel2 ?? '',
      centroCostoNivel2Info: editarData.centroCostoNivel2Info ?? '',
      flagCentroCosto: editarData.flagCentroCosto ?? false
    }
  }, [editarData, idSocio, idTituloViatico])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      const funcionSubmit = editarData._id
        ? () => CajaChicaService.actualizarSinDocumentoxId(editarData._id, data)
        : () => CajaChicaService.nuevoSinDocumento(data)

      funcionSubmit()
        .then(() => {
          __zariContext.toast('success', 'Registro guardado.')
          mostrarListaSection()
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
          setSubmitting(false)
        })
    },
    [__zariContext, editarData, mostrarListaSection]
  )

  return (
    <>
      <Row>
        <Col md={6}>
          <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
            {({ errors, touched, values, isSubmitting, setFieldValue, handleSubmit }) => (
              <Form>
                <Row>
                  <Col md={6}>
                    <FormGroups.FechaEmisionFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.fechaEmision}
                      iTouched={touched.fechaEmision}
                    />
                  </Col>
                  <Col md={6}>
                    <FormGroups.TipoCambioFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.tipoCambio}
                      iTouched={touched.tipoCambio}
                      iFechaEmision={values.fechaEmision}
                      setFieldValue={setFieldValue}
                    />
                  </Col>
                </Row>
                <FormGroups.GlosaFormGroup
                  fIsSubmitting={isSubmitting}
                  iError={errors.glosa}
                  iTouched={touched.glosa}
                />
                <Row>
                  <Col md={6}>
                    <FormGroups.ImporteFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.importe}
                      iTouched={touched.importe}
                    />
                  </Col>
                  <Col md={6}>
                    <FormGroups.MonedaFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.moneda}
                      iTouched={touched.moneda}
                    />
                  </Col>
                </Row>
                <FormGroups.CuentaContableFormGroup
                  fIsSubmitting={isSubmitting}
                  iError={errors.cuentaContable}
                  iTouched={touched.cuentaContable}
                  setFieldValue={setFieldValue}
                  iValue={values.cuentaContableInfo}
                />
                {values.flagCentroCosto && (
                  <>
                    <FormGroups.CentroCostoNivel1FormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors._idCentroCostoNivel1}
                      iTouched={touched._idCentroCostoNivel1}
                      setFieldValue={setFieldValue}
                    />
                    {values._idCentroCostoNivel1 && (
                      <FormGroups.CentroCostoNivel2FormGroup
                        fIsSubmitting={isSubmitting}
                        iError={errors._idCentroCostoNivel2}
                        iTouched={touched._idCentroCostoNivel2}
                        setFieldValue={setFieldValue}
                        iValue={values.centroCostoNivel2Info}
                        idNodoPadre={values._idCentroCostoNivel1}
                      />
                    )}
                  </>
                )}
                <Row>
                  <Col md={12} className='text-right'>
                    <Button tiny outline color='secondary' onClick={mostrarListaSection}>
                      Cancelar
                    </Button>
                    <Button id='button-nuevoSinDoc-procesar' tiny disabled={isSubmitting} onClick={handleSubmit}>
                      Procesar
                    </Button>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Col>
      </Row>
    </>
  )
}

export default React.memo(MainForm)
